/* eslint-disable max-len */
import createAxios from 'config/axios'

const getCustodyInvestmentsV1 = async () => {
  try {
    const response = await createAxios.get('/aparatar/v1/transfer/order', undefined, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('access_token')}`
      }
    })

    return response
  } catch (e) {
    return e
  }
}
const getCustodyInvestmentsV2 = async () => {
  try {
    const response = await createAxios.get('/aparatar/v2/transfer/order', undefined, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('access_token')}`
      }
    })

    return response
  } catch (e) {
    return { status: 500 }
  }
}

const joinCustodyInvestments = async () => {
  const [responseV1, responseV2] = await Promise.all([getCustodyInvestmentsV1(), getCustodyInvestmentsV2()])

  if (responseV1.status === 200 && responseV2.status === 200) {
    const fundsCustody = responseV2.data
    const otherInvestmentsCustody = responseV1.data || {}
    const investmentsData = otherInvestmentsCustody.investments || {}
    const summaryData = investmentsData.summary || {}

    return {
      ...responseV1,
      data: {
        ...fundsCustody,
        ...otherInvestmentsCustody,
        investments: {
          items: (investmentsData.items || []).concat(fundsCustody.investments.items),
          summary: {
            totalAmount: (summaryData.totalAmount || 0) + fundsCustody.investments.summary.totalAmount,
            totalAmountRounded: (summaryData.totalAmountRounded || 0) + fundsCustody.investments.summary.totalAmountRounded,
            totalQuantity: (summaryData.totalQuantity || 0) + fundsCustody.investments.summary.totalQuantity,
            totalQuantityRounded: (summaryData.totalQuantityRounded || 0) + fundsCustody.investments.summary.totalQuantityRounded,
            investments: (summaryData.investments || []).concat(fundsCustody.investments.summary.investments)
          }
        }
      }
    }
  }

  if (responseV2.status === 200) {
    return responseV2
  }

  if (responseV1.status !== 200) {
    throw responseV1
  }

  return responseV1
}


// eslint-disable-next-line import/prefer-default-export
export const getCustodyInvestments = () => joinCustodyInvestments()
